var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "407", height: "142", viewBox: "0 0 407 142", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "title",
      null,
      "Creator card"
    ),
    React.createElement(
      "defs",
      null,
      React.createElement("rect", { id: "b", width: "395", height: "130", rx: "4" }),
      React.createElement(
        "filter",
        { x: "-2.5%", y: "-6.2%", width: "105.1%", height: "115.4%", filterUnits: "objectBoundingBox", id: "a" },
        React.createElement("feOffset", { dy: "2", "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
        React.createElement("feGaussianBlur", { stdDeviation: "3", "in": "shadowOffsetOuter1", result: "shadowBlurOuter1" }),
        React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0", "in": "shadowBlurOuter1" })
      ),
      React.createElement("path", { d: "M0 3.997A3.996 3.996 0 0 1 3.997 0H130v130H3.997A3.996 3.996 0 0 1 0 126.003V3.997z", id: "c" })
    ),
    React.createElement(
      "g",
      { transform: "translate(6 4)", fill: "none", fillRule: "evenodd" },
      React.createElement("use", { fill: "#000", filter: "url(#a)", xlinkHref: "#b" }),
      React.createElement("use", { fill: "#FFF", xlinkHref: "#b" }),
      React.createElement(
        "mask",
        { id: "d", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#c" })
      ),
      React.createElement("use", { fill: "#FFF", xlinkHref: "#c" }),
      React.createElement("path", { fill: "#6ED7D8", fillRule: "nonzero", mask: "url(#d)", d: "M-1 0h130v130H-1z" }),
      React.createElement("path", { d: "M34.406 71.375c-4.198 3.414-7.49 8.23-10.209 13.258a1.693 1.693 0 0 0-.035 1.516c14.484 30.133 62.34 30.766 79.815.101.259-.45.286-1.023.078-1.496-2.224-8.465-15.921-20.16-24.368-17.55-10.447 6.788-19.716 6.624-29.14.03-5.585-1.656-12.394 1.149-16.145 4.137l.004.004z", fill: "#FFF", opacity: ".8", mask: "url(#d)" }),
      React.createElement("path", { d: "M39.564 73.728c-3.454 2.747-6.165 6.622-8.402 10.667-.206.371-.216.84-.029 1.22 11.921 24.244 51.307 24.754 65.69.081.212-.36.234-.823.064-1.203-1.831-6.81-13.104-16.22-20.056-14.121-8.598 5.462-16.226 5.33-23.983.025-4.596-1.333-10.2.924-13.287 3.328l.003.003z", fill: "#FFF", opacity: ".9", mask: "url(#d)" }),
      React.createElement("path", { d: "M64.08 21c-12.782 0-23.186 10.332-23.186 23.059 0 12.688 10.404 23.02 23.185 23.02 12.816 0 23.225-10.328 23.225-23.02C87.304 31.332 76.895 21 64.079 21z", fill: "#FFF", opacity: ".8", mask: "url(#d)" }),
      React.createElement("path", { d: "M63.986 23C54.622 23 47 30.624 47 40.014 47 49.376 54.622 57 63.986 57 73.375 57 81 49.38 81 40.014 81 30.624 73.375 23 63.986 23z", fill: "#FFF", opacity: ".9", mask: "url(#d)" }),
      React.createElement("rect", { fill: "#E2E5E5", fillRule: "nonzero", x: "149", y: "39", width: "96", height: "17", rx: "8" }),
      React.createElement("rect", { fill: "#F4F4F4", fillRule: "nonzero", x: "149", y: "74", width: "191", height: "17", rx: "8" })
    )
  );
});